<template>
  <main class="settings-page">
    <header class="settings-header">
      <button type="button" aria-label="Back" @click="back"><van-icon name="arrow-left" /></button>
      <h1>set up</h1>
      <span></span>
    </header>

    <section class="settings-list">
      <button type="button" @click="toInfomation"><span>Basic Information</span><van-icon name="arrow" /></button>
      <button type="button" @click="toLoginPassword"><span>Login Password</span><van-icon name="arrow" /></button>
      <button type="button" @click="toPayPassword"><span>Fund password</span><b>{{ userInfo.paypassword || 'Has been set' }}</b><van-icon name="arrow" /></button>
      <button type="button" @click="toLanguage"><span>language selection</span><van-icon name="arrow" /></button>
    </section>

    <button class="settings-logout" type="button" @click="loginout">Log Out</button>
  </main>
</template>

<script>
import { clearSession } from '../../common/language';
export default {
  data() {
    return {
      userInfo:{}
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    toPayPassword(){
      if(this.userInfo.paypassword !== this.$t("setting.no_setting")){
        this.$toast(this.$t("withdraw.with_service"));
      }else {
        this.$router.push({path:'/SetPayPassword'});
      }
    },
    toLoginPassword(){
      this.$router.push({path:'/SetLoginPassword'});
    },

    toLanguage(){
      this.$router.push({
        name:'Language',
        params: {
          "type": "setting"
        }
      });
    },
    toInfomation(){
      this.$router.push({path:'/Infomation'});
    },
    loginout(){
      clearSession()
        this.$router.push({path:'/Mine'});
    },
    toServicePage(){
      this.$router.push("ServicePage");
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          if(res.data.paypassword){
            this.userInfo.paypassword = this.$t("setting.y_setting");
          }else {
            this.userInfo.paypassword = this.$t("setting.no_setting");
          }
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
    }
  }
};
</script>

<style scoped>
.settings-page {
  min-height: 100vh;
  background: #f4f4f7;
}

.settings-header {
  height: 3.25rem;
  display: grid;
  grid-template-columns: 3rem 1fr 3rem;
  align-items: center;
  color: #fff;
  background: linear-gradient(105deg, #7c48aa, #9661c7);
}

.settings-header button {
  border: 0;
  background: transparent;
  color: #fff;
  font-size: 1.32rem;
}

.settings-header h1 {
  margin: 0;
  color: #fff;
  font-size: 1.02rem;
  font-weight: 500;
  text-align: center;
}

.settings-list {
  padding: 0 0.8rem;
  background: #fff;
}

.settings-list button {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 3.28rem;
  padding: 0;
  border: 0;
  border-bottom: 0.04rem solid #f0eff2;
  background: #fff;
  color: #111;
  font-size: 0.86rem;
  text-align: left;
}

.settings-list button:last-child { border-bottom: 0; }
.settings-list button span { flex: 1; }
.settings-list button b { margin-right: 0.2rem; color: #9996a1; font-size: 0.79rem; font-weight: 700; }
.settings-list button .van-icon { color: #111; font-size: 0.86rem; }

.settings-logout {
  display: block;
  width: calc(100% - 1.5rem);
  height: 3.35rem;
  margin: 17.8rem auto 0;
  border: 0;
  border-radius: 999px;
  color: #fff;
  background: #8b57c2;
  font-size: 1.18rem;
  font-weight: 700;
}
</style>
